module.exports = __webpack_public_path__ + "static/media/status.57a80e8e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/venueStatus/status.svg
// module id = 1404
// module chunks = 1